import { FC, useState } from 'react';
import moment from 'moment';
import { IStaff } from '../../../models/employees.model';
import { Descriptions } from 'antd';
import { addHyphen } from '../../../lib/util';
import { getCommonCodeLabel } from '../../../lib/store';
import Button from '../../Button';
import RetireEmployeeModal from './modals/RetireEmployeeModal';
import { useTranslation } from 'react-i18next';
import i18n from '../../../lib/i18n';

interface IProps {
  staff: IStaff|undefined;
  getStaff: (memberCode: string) => void;
}

const StaffInfo: FC<IProps> = ({
  staff,
  getStaff,
}) => {
  const { t } = useTranslation();

  const [retireEmployeeVisible, setRetireEmployeeVisible] = useState(false);

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        size="small"
        column={2}
        labelStyle={{ width: '15%' }}
        contentStyle={{ width: '35%' }}
      >
        <Descriptions.Item label={t('campus.staff.column1')}>
          {staff?.enterDate ? moment(staff.enterDate).format('YYYY.MM.DD') : '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.status')}>
          <span className='comm-gap align-items-center'>
            {getCommonCodeLabel('MB0015', staff?.employeeStatus || '', i18n.language)}
          {
            
            staff?.employeeStatus === '02'
              ? ` (${moment(staff.retireDate).format('YYYY.MM.DD')})`
              : (  
                  <Button
                    className="btn-basic small gray"
                    onClick={() => setRetireEmployeeVisible(true)}
                    text={t('campus.staff.2')}
                  /> 
                )
          }
          </span>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.phoneNum')}>
          {staff?.mobilePhone ? addHyphen(staff.mobilePhone) : '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.eMail')}>
          {staff?.email || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.address1')}>
          {staff?.address || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.address2')}>
          {staff?.detailAddress || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t('campus.staff.column2')}>
          {staff?.className?.map((item, index) => (
            <>{index + 1}. {item}<br /></>
          ))}
        </Descriptions.Item>
      </Descriptions>

      {retireEmployeeVisible && (
        <RetireEmployeeModal
          visible={retireEmployeeVisible}
          setVisible={setRetireEmployeeVisible}
          memberCode={staff?.memberCode}
          getStaff={getStaff}
        />
      )}
    </div>
  );
}

export default StaffInfo;
